// src/pages/CsvDashboard.js
import React, { useState, useEffect } from 'react';

const allowedEmails = ["anand.pathak@digiadglobal.com", "sales@digidayin.com", "shridhar.mishra@digiadglobal.com", "ashish.gupta@digiadglobal.com",'anand.maheshwari@digiadglobal.com'];

const CSV_FILES = [
  "topic_insights.csv for Topic Insights",
  "data-behaviors1.csv",
  "data-Audience-Intrest.csv",
  "data-Demographic.csv",
  "data-Purchase-Intent.csv",
  "data-Manage-Behavior.csv",
  "data-Signals.csv",
  "data.csv",
  "abc.csv",
  "insightsrealtime.csv",
  "keyword_search_responses.csv"
];

const BUCKET_BASE = "https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics";

const BASE_URL = process.env.REACT_APP_API_URL;

const CsvDashboard = ({ user }) => {
  const [emailAllowed, setEmailAllowed] = useState(false);

  useEffect(() => {
    if (user?.email && allowedEmails.includes(user.email)) {
      setEmailAllowed(true);
    }
  }, [user]);

  const handleFileUpload = async (e, filename) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('filename', filename); // 👈 matches backend now
    formData.append('email', user.email);

    try {
      const response = await fetch(`${BASE_URL}/engage/api/csv/upload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error('Upload failed');
      alert('✅ Upload successful!');
    } catch (err) {
      console.error('❌ Upload error:', err);
      alert('❌ Upload failed');
    }
  };

  if (!emailAllowed) return <div className="p-4 text-red-500">⛔ Access Denied</div>;

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">📂 CSV Dashboard</h1>
      <div className="grid grid-cols-1 gap-4">
        {CSV_FILES.map((file) => (
          <div key={file} className="border p-4 rounded shadow">
            <p className="font-semibold">{file}</p>
            <div className="flex gap-4 mt-2">
              <a
                href={`${BUCKET_BASE}/${file}`}
                download
                className="px-4 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Download
              </a>
              <input
                type="file"
                accept=".csv"
                onChange={(e) => handleFileUpload(e, file)}
                className="border p-1"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CsvDashboard;
